import { BaseController } from "./baseController";

export class BaseGridApi {
	/** Loads saved grid settings for a specific grid */
	static loadGridSettings(controller: string, gridName: string) {
		const Get = BaseController.GetFn(controller);
		return Get<string | null>("LoadSettingsDyn", { gridName });
	}

	/** Saves grid settings for a specific grid. Pass empty string to clear. */
	static saveGridSettings(controller: string, gridName: string, settingsJson: string) {
		const Post = BaseController.PostFn(controller);
		return Post<void>("SaveSettings", null, {
			settings: settingsJson,
			gridName,
		});
	}

	/** Gets grid column definitions from the backend */
	static getGridColumns<T>(controller: string, gridName: string) {
		const Get = BaseController.GetFn(controller);
		return Get<T>("GetGridColumns", { gridName });
	}
}
